module.exports = __webpack_public_path__ + "32f3afdcb591e50462f3983ec79b45a1.MP3";